<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command-container">
      <div class="table-command">
        <span class="table-command-item-key dh-right">{{ bridgeName }}</span>
        <div class="table-command-item">
          <span class="table-command-item-key">设备组:</span>
          <el-select v-model="selectedStation" placeholder="请选择设备组">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName" :value="item.stationId"></el-option>
          </el-select>
        </div>
        <div class="table-command-item">
          <span class="table-command-item-key">设备状态:</span>
          <el-select v-model="selectedStatusType" placeholder="请选择设备状态">
            <el-option v-for="item in statusTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="table-command-right">
        <el-button @click="approveDevice()" type="primary">开始高频提交</el-button>
        <el-button @click="stopDialogVisible = true" type="primary">停止高频提交</el-button>
      </div>
    </div>

    <el-table :data="rowList_current" style="width: 100%" :max-height="tableMaxHeight" :cell-class-name="tableCellClassName">
      <el-table-column align="center" label="设备名" prop="deviceName1"></el-table-column>
      <el-table-column align="center" label="提交状态" width="100">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.statusClass1">{{ scope.row.status1 }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间" prop="endDate1"></el-table-column>
      <!-- <el-table-column align="center" label="操作" width="100"> </el-table-column> -->
      <el-table-column align="center" label="设备名" prop="deviceName2"></el-table-column>
      <el-table-column align="center" label="提交状态" width="100">
        <template slot-scope="scope" v-if="scope.row.data2Exist">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.statusClass2">{{ scope.row.status2 }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间" prop="endDate2"></el-table-column>
      <!-- <el-table-column align="center" label="操作" width="100"> </el-table-column> -->
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      :current-page.sync="currentPage"
      ref="page"
    ></el-pagination>
    <!-- 批准高频弹窗 -->
    <el-dialog title="批准高频提交" :visible.sync="approveDialogVisible" width="30%" v-loading="approveDialogLoading">
      <el-form :model="approveDialogModel" label-width="80px">
        <el-form-item label="批准目标">
          <span>{{ approveDialogModel.targetName }}</span>
        </el-form-item>
        <el-form-item label="起始时间">
          <el-select v-model="approveDialogModel.approveStartType" placeholder="请选择起始时间">
            <el-option v-for="item in approveStartTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="approveDialogModel.approveStartType === 'SELECT_DATE'" label="起始时间">
          <el-date-picker
            class="date-time"
            v-model="approveDialogModel.approveStartDate"
            type="datetime"
            placeholder="选择日期时间"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="允许时间">
          <el-select v-model="approveDialogModel.approveHours" placeholder="请选择允许时间">
            <el-option v-for="item in approveHourOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="message">
          <el-input
            type="textarea"
            v-model="approveDialogModel.comment"
            placeholder="请输入备注信息(可选)"
            :rows="5"
            resize="none"
            class="dialog-form-textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitApproveDialog()">提交</el-button>
      </span>
    </el-dialog>
    <!--提交成功弹窗-->
    <el-dialog
      width="620px"
      :visible.sync="stopDialogVisible"
      v-loading="stopDialogLoading"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div class="dialog-title" slot="title">确认</div>
      <span>停止当前设备组的所有高频提交, 并取消尚未开始的高频提交. 确定吗?</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="stopDialogVisible = false">取消</el-button>
        <el-button @click="submitStopDialog()" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "SimpleCurrentData",
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      bridgeId: "",
      bridgeName: "",
      bridgeHasErrorRecord: false,
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      historyScenarioCurrentGroupNameList: [],
      stationIdStationNameDict: {},

      statusTypeOptions: [
        {
          id: "ALL",
          name: "全部",
        },
        {
          id: "PENDING",
          name: "正常提交",
        },
        {
          id: "WORKING",
          name: "高频提交",
        },
      ],

      routeBridgeId: "",
      deviceIdDeviceNameDict: {},
      stationList: [],
      selectedStation: "",
      selectedStatusType: "ALL",

      stopDialogVisible: false,
      stopDialogLoading: false,

      rowList_all: [],
      rowList_current: [],

      dataList_all: [],
      dataList_pending: [],
      dataList_working: [],

      approveDialogVisible: false,
      approveDialogLoading: false,
      approveHourOptions: [
        { label: "1小时", value: 1 },
        { label: "2小时", value: 2 },
        { label: "4小时", value: 4 },
        { label: "8小时", value: 8 },
        { label: "12小时", value: 12 },
        { label: "1天", value: 24 },
        { label: "2天", value: 48 },
        { label: "5天", value: 120 },
        { label: "7天", value: 168 },
        { label: "14天", value: 336 },
        { label: "21天", value: 504 },
      ],
      approveStartTypeOptions: [
        { label: "立刻开始", value: "NOW" },
        { label: "选择时间", value: "SELECT_DATE" },
      ],
      approveDialogModel: {
        stationId: "",
        targetName: "",
        approveHours: 168,
        approveStartType: "NOW",
        approveStartDate: "",
        comment: "",
      },
    };
  },
  computed: {
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.initializeStationAndGetData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    $route(route) {
      if (this.$route.query.bridgeId !== this.routeBridgeId) {
        this.initializeStationAndGetData();
      }
    },
    selectedStatusType() {
      this.dataTypeOnChange();
    },
    selectedStation() {
      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
  },
  methods: {
    initializeStationAndGetData() {
      this.loading = true;
      this.routeBridgeId = this.$route.query.bridgeId;

      let routeBridgeIdConfirmed = false;
      this.bridgeList.forEach((bridge) => {
        if (bridge.id === this.routeBridgeId) {
          routeBridgeIdConfirmed = true;
          //break
          return false;
        }
      });

      if (!routeBridgeIdConfirmed) {
        this.$alert("无效的桥梁编号", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });

        return;
      }

      this.stationList = [];
      this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
        this.bridgeHasErrorRecord = res.data.recordDataErrorReporForWebpage;
        res.data.stationList.forEach((stationItem) => {
          this.stationList.push({
            stationId: stationItem.stationId,
            stationName: stationItem.stationName,
          });
          this.stationIdStationNameDict[stationItem.stationId] = stationItem.stationName;
        });

        this.$nextTick(() => {
          if (this.stationList.length > 0) {
            this.selectedStation = this.stationList[0].stationId;
          }

          this.bridgeName = res.data.bridgeName;
          this.currentPage = 1;
          this.getDataList();
        });
      });
    },
    hrefErrorRecord() {
      let url = this.$route.path;
      let firstSlash = url.indexOf("/");
      if (firstSlash < 0) {
        return;
      }
      let secondSlash = url.indexOf("/", firstSlash + 1);
      if (secondSlash < 0) {
        return;
      }

      let result = url.slice(0, secondSlash);
      result = result + "/errorRecord?bridgeId=" + this.routeBridgeId + "&stationId=" + this.selectedStation;
      this.$router.push(result);
    },
    approveDevice() {
      this.approveDialogModel.stationId = this.selectedStation;
      var stationName = this.stationIdStationNameDict[this.selectedStation];
      if (stationName.indexOf("设备组") < 0) {
        stationName = stationName + "设备组";
      }
      this.approveDialogModel.targetName = this.bridgeName + " - " + stationName;
      this.approveDialogModel.approveHours = 168;
      this.approveDialogModel.comment = "";
      (this.approveStartType = "NOW"), (this.approveStartDate = ""), (this.approveDialogVisible = true);
    },
    submitApproveDialog() {
      this.approveDialogLoading = true;
      let postBody = {
        targetId: this.approveDialogModel.stationId,
        targetType: "STATION",
        approveHours: this.approveDialogModel.approveHours,
        comment: this.approveDialogModel.comment,
      };
      if (this.approveDialogModel.approveStartType === "SELECT_DATE") {
        postBody.startDate = this.approveDialogModel.approveStartDate;
      }

      this.$http
        .post("/highFrequencyDevice/InsertHighFrequencyDeviceApproveWork", postBody)
        .then(() => {
          this.approveDialogLoading = false;
          this.approveDialogVisible = false;
          this.getDataList();
          this.$message({ message: "提交成功", type: "success" });
        })
        .catch(() => {
          this.approveDialogLoading = false;
        });
    },
    submitStopDialog() {
      this.stopDialogLoading = true;

      let postBody = {
        stationId: this.selectedStation,
      };

      this.$http
        .post("/highFrequencyDevice/StopHighFrequencyDeviceByStation", postBody)
        .then(() => {
          this.stopDialogLoading = false;
          this.stopDialogVisible = false;
          this.getDataList();
          this.$message({ message: "停止成功", type: "success" });
        })
        .catch(() => {
          this.stopDialogLoading = false;
        });
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return "table-row-spliter";
      } else {
        return "";
      }
    },
    dataTypeOnChange() {
      this.filterDataByDataType();
      this.currentChange(1);
    },
    filterDataByDataType() {
      let val = this.selectedStatusType;

      if (val === "ALL") {
        this.rowList_all = this.assembleDataRow(this.dataList_all);
      } else if (val === "PENDING") {
        this.rowList_all = this.assembleDataRow(this.dataList_pending);
      } else if (val === "WORKING") {
        this.rowList_all = this.assembleDataRow(this.dataList_working);
      } else {
        this.rowList_all = [];
      }

      this.totalCount = this.rowList_all.length;
    },
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;

      let result = [];
      let pageStart = (this.currentPage - 1) * this.pageSize;
      for (let i = 0; i < this.pageSize; i++) {
        let actualIndex = pageStart + i;
        if (actualIndex >= this.rowList_all.length) {
          break;
        }

        result.push(this.rowList_all[actualIndex]);
      }

      this.rowList_current = result;

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getDataCount() {
      this.$http.get("/user/GetUserLoginRecordCount?userId=" + this.routeUserId).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      this.loading = true;

      if (!this.selectedStation || this.selectedStation === "") {
        this.dataList_all = [];
        this.dataList_pending = [];
        this.dataList_working = [];

        this.filterDataByDataType();
        this.currentChange(this.currentPage);
        setTimeout(() => {
          this.loading = false;
        }, 500);

        return;
      }

      let metaQuery = this.$http.get("/bridge/stationInfo?stationId=" + this.selectedStation);
      let dataQuery = this.$http.get("/highFrequencyDevice/GetHighFrequencyDeviceStatusByStation?stationId=" + this.selectedStation);
      this.$http.all([metaQuery, dataQuery]).then(
        this.$http.spread((metaRes, dataRes) => {
          this.deviceIdDeviceNameDict = {};
          metaRes.data.deviceList.forEach((deviceItem) => {
            this.deviceIdDeviceNameDict[deviceItem.deviceId] = deviceItem.deviceName;
          });

          this.dataList_all = [];
          this.dataList_working = [];
          this.dataList_pending = [];

          for (let rawDataItem of dataRes.data) {
            let dataItem = {
              deviceId: rawDataItem.deviceId,
              status: rawDataItem.DeviceApproveWorkStatus,
              endDate: rawDataItem.DeviceApproveEndDate,
              DeviceApproveWorkStatus: rawDataItem.DeviceApproveWorkStatus,
            };
            if (this.deviceIdDeviceNameDict[dataItem.deviceId]) {
              dataItem.deviceName = this.deviceIdDeviceNameDict[dataItem.deviceId];
            }
            if (dataItem.DeviceApproveWorkStatus === "一般设备") {
              dataItem.statusClass = "info";
            } else if (dataItem.DeviceApproveWorkStatus === "正常提交") {
              dataItem.statusClass = "primary";
            } else if (dataItem.DeviceApproveWorkStatus === "高频提交") {
              dataItem.statusClass = "danger";
            } else {
              dataItem.statusClass = "info";
            }

            this.dataList_all.push(dataItem);
            if (dataItem.DeviceApproveWorkStatus === "高频提交") {
              this.dataList_working.push(dataItem);
            } else {
              this.dataList_pending.push(dataItem);
            }
          }

          this.filterDataByDataType();
          this.currentChange(this.currentPage);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
      );
    },
    assembleDataRow(dataList) {
      let result = [];
      for (let i = 0; i < dataList.length; i += 2) {
        let rawItem = dataList[i];
        let item = {
          deviceName1: rawItem.deviceName,
          status1: rawItem.status,
          endDate1: rawItem.endDate,
          statusClass1: rawItem.statusClass,
        };

        rawItem = dataList[i + 1];
        if (rawItem) {
          item.deviceName2 = rawItem.deviceName;
          item.status2 = rawItem.status;
          item.endDate2 = rawItem.endDate;
          item.statusClass2 = rawItem.statusClass;

          item.data2Exist = true;
        } else {
          item.data2Exist = false;
        }

        result.push(item);
      }

      return result;
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .table-command {
    display: flex;
  }
  .table-command-right {
    display: flex;
    margin-right: 60px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

.error-level-tag {
  min-width: 75px;
}

.date-time {
  width: 202px;
}

::v-deep .table-row-spliter {
  border-right: 1px solid #ebeff0;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
  